import { Component, inject, input } from '@angular/core';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';

import { MenuService, ModalService } from '../../../services';
import { ignoreModalError } from '../../../helpers';
import { DeleteModalComponent } from '../../modals/delete-modal/delete-modal.component';

@Component({
  selector: 'app-formly-repeat',
  templateUrl: './formly-repeat.component.html',
  styleUrl: './formly-repeat.component.scss',
  imports: [FormlyModule],
})
export class FormlyRepeatComponent extends FieldArrayType {
  protected readonly menuService = inject(MenuService);
  private readonly modalService = inject(ModalService);

  public readonly newAtTop = input(true);

  delete(index: number) {
    this.modalService
      .openSmall<DeleteModalComponent>(DeleteModalComponent)
      .modal.result.then(() => this.remove(index), ignoreModalError);
  }
}
